<script>
  import {TreeSelect} from 'ant-design-vue';

  export default {
    name: 'dol-tree-select',
    props: {
      value: {},                                              //value  Type  Array | String
      placeholder: {type: String, default: '--请选择--'},
      source: {type: String, default: 'server'},              //数据源，local | server
      //---------------------- if source === server --------------------------------//
      url: {type: String},                                  //后台地址
      method: {type: String, default: 'get'},              //请求方式
      queryParams: {
        type: Object, default() {
          return {};
        }
      },             //请求参数
      //---------------------- if source === local  --------------------------------//
      options: {
        type: Array, default() {
          return [];
        }
      },                     //可选项数据

      multiple: {type: Boolean, default: false},
      treeCheckable: {type: Boolean, default: false},
      disabled: {type: Boolean, default: false},                 //disabled
      param: {},                 //params
      maxTagCount: {type: Number, default: 3},
      defaultKeyField: {type: String, default: 'code'},                 //key
      defaultLabelField: {type: String, default: 'text'},               //label
      defaultValueField: {type: String, default: 'code'},               //value
      serverKeyField: {type: String, default: '_id'},                 //key
      serverLabelField: {type: String, default: 'name'},               //label
      serverValueField: {type: String, default: '_id'},               //value

      mode: {type: String, default: 'default'},               //default | nodePath
      onlyLeaf: {type: Boolean, default: false},               //是否只叶子可选
      treeDefaultExpandAll: {type: Boolean, default: false},
      checkWithParents: {type: Boolean, default: false},   //父子联动选择
    },
    data: function () {
      let params = {
        serverData: [],
      };
      return params;
    },
    watch: {
      url() {
        this.getOption();
      },
    },
    computed: {
      treeSelectData() {
        let data = [];
        switch (this.source) {
          case 'server':
            data = this.serverData;
            break;
          case 'local':
            data = this.options;
            break;
        }
        return data;
      },
      keyField() {
        return this.source === 'server' ? this.serverKeyField : this.defaultKeyField;
      },
      labelField() {
        return this.source === 'server' ? this.serverLabelField : this.defaultLabelField;
      },
      valueField() {
        return this.source === 'server' ? this.serverValueField : this.defaultValueField;
      },

      treeSelectValue() {
        let value;
        switch (this.mode) {
          case 'nodePath':
            this.value.length > 0 ? value = this.value[this.value.length - 1] : null;
            break;
          default:
            value = this.value;
        }
        return value;
      },
      nodeMap() {
        return this.getNodeMap(this.treeSelectData);
      },
      treeSelectMultiple() {
        let flag;
        switch (this.mode) {
          case 'nodePath':
            flag = false;
            break;
          default:
            flag = this.multiple;
        }
        return flag;
      },
      treeSelectCheckable() {
        let flag;
        switch (this.mode) {
          case 'nodePath':
            flag = false;
            break;
          default:
            flag = this.treeCheckable;
        }
        return flag;
      }
    },
    methods: {
      getOption() {
        if (this.source === 'server') {
          this.$ajax({
            url: this.url,
            method: this.method,
            params: this.queryParams,
          }).then(reData => {
            this.serverData = reData.rows;
            this.$emit('afterLoading',this.serverData)
          }).catch(e => {
            console.error(e);
            this.serverData = [];
          });
        }
      },
      input(value) {
        this.$emit('input', value);
      },
      inputValue(value, label, extra) {
        let returnValue;
        if (value === undefined) {
          returnValue = null;
        } else {
          switch (this.mode) {
            case 'nodePath':
              returnValue = this.getNodeValuePath(value);
              break;
            default:
              returnValue = value;
          }
        }
        this.$emit('input', returnValue, label, extra);
        this.$emit('change', returnValue, label, extra);
      },

      getNodeMap(data) {
        let nodeMap = {};
        data.forEach(node => {
          nodeMap[node[this.keyField]] = node;
          if (node.children) {
            Object.assign(nodeMap, this.getNodeMap(node.children));
          }
        });
        return nodeMap;
      },
      getNodeValuePath(value) {
        let nodePath = [];
        let thisNode = this.nodeMap[value];
        if (thisNode.parent) {
          if (typeof thisNode.parent === 'string') {
            nodePath = nodePath.concat(this.getNodeValuePath(thisNode.parent));
          } else {
            nodePath = nodePath.concat(this.getNodeValuePath(thisNode.parent._id));
          }
        }
        nodePath.push(value);
        return nodePath;
      }
    },
    created: function () {
      this.getOption();
    },
    render(createElement) {
      let createNode = (data, level, parent) => {
        let children = [];
        data && data.forEach(node => {
          let renderNode;
          if (typeof this.$scopedSlots.default === 'function') {
            renderNode = createElement('span', {slot: 'title'}, this.$scopedSlots.default({
              node: node,
              level: level,
              $parent: parent
            }));
          } else if (this.$slots.default) {
            renderNode = createElement('span', {slot: 'title'}, this.$slots.default);
          } else {
            renderNode = createElement('span', {slot: 'title'}, node[this.labelField]);
          }

          children.push(createElement('a-tree-select-node', {
            props: {
              value: node[this.valueField],
              key: node[this.keyField],
              title: node[this.labelField],
              disabled: this.onlyLeaf && node.children && node.children.length > 0,
            },
          }, [
            renderNode,
            ...createNode(node.children, level + 1, node),
          ]))
        });
        return children;
      };

      let params = {
        props: {
          placeholder: this.placeholder,
          value: this.treeSelectValue,
          multiple: this.treeSelectMultiple,
          showSearch: true,
          allowClear: true,
          treeNodeFilterProp: 'title',
          disabled: this.disabled,
          treeDefaultExpandAll: this.treeDefaultExpandAll,
          maxTagCount:this.maxTagCount,
          treeCheckable: this.treeSelectCheckable,
          showCheckedStrategy: TreeSelect.SHOW_ALL,
          treeCheckStrictly: false,
        },
        on: {
          change: this.inputValue
        }
      };
      if (this.checkWithParents) {
        params.props.treeCheckable = true;
        params.props.showCheckedStrategy = TreeSelect.SHOW_ALL;
      }
      return createElement('a-tree-select', params, createNode(this.treeSelectData))
    }
  }
</script>
